<template>
  <div>
    <PageAllow controller="Coupons" action="receiveHistories" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
            <SearcherShops v-model="shopsSelected"/>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.use_flgs"
                    :items="$consts.coupons.coupon_use_flgs"
                    :label="$t('MaterialCoupons.Status.title')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="receive_histories"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <!--  状态  -->
          <template v-slot:item.use_flg="{ item }">
            <v-chip
              small
              label
              dark
              :color="item.use_flg ==1 ? 'grey' : 'primary'"
            >
              {{
                item.use_flg == 1
                  ? $t("MaterialCoupons.use_flgs.off")
                  : $t("MaterialCoupons.use_flgs.on")
              }}
            </v-chip>
          </template>

          <!-- 创建时间 -->
          <template v-slot:item.created="{ item }">
            <span>
              {{ item.created | formatTime }}
            </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Coupons from "@/api/coupons";
import i18n from "@/i18n";
import SearcherShops from "@/components/plugins/SearcherShops";

const defaultOptions = {
  shop_ids:[],
  use_flgs: [0,1],
};

export default {
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    use_flgs:[],
    paging: {},
    shopsSelected: [],
    receive_histories:[]
  }),
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/material-coupons",
      },
      {
        text: i18n.t("Nav.materialCoupons"),
        disabled: false,
        href: "/material-coupons",
      },
      {
        text: i18n.t("Nav.receiveHistories"),
        disabled: true,
        href: "/material-coupons",
      },
    ],
    headers() { 
      return [
      {
        text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
        align: "start",
        sortable: false,
        value: "shop.shop_code",
      },
      {
        text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
        align: "start",
        sortable: false,
        value: "shop.shop_name",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.shop_district", [this.$consts.shopName()]),
        align: "start",
        sortable: false,
        value: "shop.district.name",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.receive_time"),
        align: "center",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.status"),
        align: "center",
        sortable: false,
        value: "use_flg",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.order_code"),
        align: "center",
        sortable: false,
        value: "order_code",
      },
    ]
    } ,
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherShops,
    SearcherStatus,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({},this.options);
    },
    resetSearch() {
      this.shopsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getHistoriesFromAPI() {
      this.loading = true;
      Coupons.receiveHistories(Object.assign(this.options, {coupon_id:this.$route.params.id})).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.receive_histories = response.data.receive_histories;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
   
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getHistoriesFromAPI();
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : [];
      },
    },
  },
};
</script>

<style>
</style>